import {useQuery} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import ChessRestClient from '@/Api/ChessRestClient';

type CheckCancellationLimitVars = {
  batch_code: string;
  user_role: 'coach' | 'student' | 'parent';
};

type CancellationLimitResponse = {
  success: boolean;
  data?: {
    total_sessions: number;
    allowed_cancellations: number;
    current_cancellations: number;
    remaining_cancellations: number;
    will_breach: boolean;
    batch_percentage_limit: number;
    batch_type: 'personal' | 'group';
    month_start: string;
    month_end: string;
    warning_message: string;
  };
  message?: string;
};

export default function useCheckCancellationLimitApi(
  batch_code: string | null,
  user_role: 'coach' | 'student' | 'parent',
  enabled: boolean = true,
) {
  return useQuery<CancellationLimitResponse, Error>(
    ['cancellation-limit', batch_code, user_role],
    async () => {
      if (!batch_code) {
        throw new Error('Batch code is required');
      }

      const token = await getLocalStorage('access_token');
      const response = await ChessRestClient.post(
        'subscription/v1/sessions/check-cancellation-limit/',
        {
          batch_code: batch_code,
          user_role: user_role,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );

      return response.data;
    },
    {
      enabled: enabled && !!batch_code,
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: 'always',
      retry: 1,
    },
  );
}

